import React from 'react'
import Link from 'next/link'
import styles from './BrandLogo.module.scss'
import Image from 'next/image'
import { NEXT_IMAGE_QUALITY } from '~constants'
import { isStudiosProxyPage } from 'utils'
import { BrandLogoType } from '../../types'

export const BrandLogo = ({ url }: BrandLogoType) => {
  const appDomain = process.env.NEXT_PUBLIC_DOMAIN_URL

  return (
    <div className={styles['brand-logo']}>
      {url && (
        <Link href={isStudiosProxyPage() && appDomain ? appDomain : '/'}>
          <Image src={url} alt='Sphere' width='0' height='0' sizes='100vw' priority quality={NEXT_IMAGE_QUALITY} />
        </Link>
      )}
    </div>
  )
}
